export default "__VITE_ASSET__DSj8V6LD__"